import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PendingActionFromAsyncThunk, AnyAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { copyRequest, createRequest } from 'core/services/admin';
import { attemptRequest } from 'core/services/product';
import { registerAttempt } from './register';
import { IHydrate, hydrate } from 'core/actions/product/state';

export interface IOffline {
  id: number;
}

export const offlineSlice = createSlice({
  name: 'offline',
  initialState: { id: -1 },
  reducers: {
    generateOfflineId: (state, action) => {
      state.id -= action.payload || 1;
    },
  },
  extraReducers: builder => {
    builder.addCase(createRequest.pending, state => {
      state.id = state.id - 1;
    });
    builder.addCase(copyRequest.pending, (state, action: PendingActionFromAsyncThunk<AnyAsyncThunk>) => {
      if (action.meta.arg?.items) state.id -= action.meta.arg.items.length;
    });
    builder.addCase(attemptRequest.pending, (state, action: PendingActionFromAsyncThunk<AnyAsyncThunk>) => {
      state.id = state.id - 1;
    });
    builder.addCase(registerAttempt, (state, action: PendingActionFromAsyncThunk<AnyAsyncThunk>) => {
      state.id = state.id - 1;
    });
    builder.addCase(hydrate, (state, action: PayloadAction<Partial<IHydrate>>) => {
      if (action.payload.offlineId) state.id = action.payload.offlineId;
    });
  },
});

export const { generateOfflineId } = offlineSlice.actions;

export default offlineSlice.reducer;
